import { Children, cloneElement, isValidElement, useCallback } from "react"

export const DragTarget = ({ children, kind, data, version = 1, onDragStart, ...props }) => {
    const handleDragStart = useCallback(e => {
        e.dataTransfer.setData('application/x-chronicler-' + kind, JSON.stringify({ version, data }));
        onDragStart?.();
    }, [kind, data, version, onDragStart]);

    return Children.map(children, (child) => {
        if (!isValidElement(child) || data === null || data === undefined) {
            return child;
        }
        return cloneElement(child, {
            draggable: true,
            onDragStart: handleDragStart,
            ...props
        });
    })
}

export const DropTarget = ({ children, kind, version = 1, onDrop: dropHandler, ...props }) => {
    const onDragOver = useCallback(e => {
        e.preventDefault();
        let data = e.dataTransfer.getData('application/x-chronicler-' + kind);
        if (data) {
            try {
                data = JSON.parse(data);
                if (data.version === version) {
                    e.dataTransfer.dropEffect = 'move'
                }
            } catch {

            }
        }
    }, [kind, version]);

    const onDrop = useCallback(e => {
        let data = e.dataTransfer.getData('application/x-chronicler-' + kind);
        if (data) {
            try {
                data = JSON.parse(data);
                if (data.version === version) {
                    dropHandler?.(data.data);
                }
            } catch {

            }
        }
    }, [kind, version, dropHandler])

    return Children.map(children, (child) => {
        if (!isValidElement(child) || !dropHandler) {
            return child;
        }
        return cloneElement(child, { onDragOver, onDrop, ...props });
    })
}